// extracted by mini-css-extract-plugin
export var card = "_a5-0";
export var expandedCard = "_a5-2";
export var paginated = "_a5-1";